import { ProjectInvoice } from '../types';

/**
 * El NÚMERO que se le enseña a una persona en una factura de obra.
 *
 * Hasta la Ola 2, el folio que teclea el contratista ERA el `id` de la factura.
 * Ahora el `id` lo pone `nuevoId()` y el folio vive en `number`, así que la
 * pantalla tiene que preguntar por el folio y no por la identidad.
 *
 * Las filas ya guardadas no traen `number`: su folio ES su `id` (en producción
 * hay una que se llama '24124 ', con el espacio final incluido), de ahí la
 * caída de vuelta a `id`. Sin ella, el portal del cliente le enseña al dueño de
 * la casa un `a3f1c0d2-58cc-…` donde antes decía «24124».
 *
 * Vive aquí y no dentro de `ProjectFinancials` porque lo lee también
 * `views/ClientBillingView`, y esa pantalla no puede arrastrar el componente de
 * finanzas entero —con Supabase Storage detrás— para resolver un folio.
 */
export function folioFactura(inv: Pick<ProjectInvoice, 'id' | 'number'>): string {
    return inv.number?.trim() || inv.id;
}
